import React, { Component } from "react";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./TipCommun.css";

class TipCommun extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  postInfoCard = () => {
    const emailVerif = RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    if (emailVerif.test(this.state.email) == false) {
      alert(
        "Le format de votre adresse mail est incorrect veuillez réessayer."
      );
    } else {
      // On mémorise les infos client puis on passe à la page de paiement Stripe
      localStorage.setItem("@dataFirstName", this.state.firstname || "");
      localStorage.setItem("@dataLastName", this.state.lastname || "");
      localStorage.setItem("@dataMail", this.state.email || "");
      this.props.history.push("/TipCommun1" + window.location.search);
    }
  };
  componentDidMount() {}
  render() {
    return (
      <Container className="mainBlocCommun">
        <Row>
          <Col className="blocCommun" xs={12} s={12} md={12}>
            <p className="titleCommun">Information client</p>
          </Col>
          <Col className="formCommun" xs={12} s={12} md={12}>
            <Form className="formCommun">
              <Form.Group className="formCommunGrp" controlId="formGroupAmount">
                <Form.Control
                  className="formMail inputPaymentTips"
                  name="email"
                  type="text"
                  placeholder="E-Mail"
                  onChange={this.handleInput}
                  value={this.state.email}
                />
                <Form.Control
                  name="lastname"
                  type="text"
                  placeholder="Nom"
                  onChange={this.handleInput}
                  value={this.state.lastname}
                  className="inputPaymentTips"
                />
                <Form.Control
                  name="firstname"
                  type="text"
                  placeholder="Prénom"
                  onChange={this.handleInput}
                  value={this.state.firstname}
                  className="inputPaymentTips"
                />
              </Form.Group>
            </Form>
          </Col>
          <Col className="ButtonCol" xs={12} s={12} md={12}>
            <Button className="communButton" onClick={this.postInfoCard}>
              Continuer vers la page de paiement
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default TipCommun;
